export const sentry_errors = [
	'TypeError: Failed to fetch',
	'TypeError: NetworkError when attempting to fetch resource.',
	'TypeError: cancelled',
	'TypeError: Cancelled',
];
